export default __webpack_public_path__ + "static/media/typing_click.1b31c6bb.wav";